import { locales } from "@packages/sdk";

export const getLocalesAsParams = () => locales.map((locale) => ({ locale }));
